const STORAGE_KEY = 'ihh-category-scroll-restore:v1';
const RESTORE_TTL = 15000;
const LINK_SELECTOR = [
  '.ihh-category__nav a[href]',
  '.facets-top-filters a[href]',
  '.facets-top-tabs a[href]',
  '.facets-block-wrapper--horizontal a[href]',
].join(',');

const normalizeUrl = (href) => {
  const url = new URL(href, window.location.href);
  url.hash = '';
  url.searchParams.sort();
  return url.href;
};

const getScrollY = () => {
  return Math.round(
    window.scrollY ||
      window.pageYOffset ||
      document.scrollingElement?.scrollTop ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
  );
};

const canStore = () => {
  try {
    sessionStorage.setItem('__ihh_scroll_test__', '1');
    sessionStorage.removeItem('__ihh_scroll_test__');
    return true;
  } catch (_error) {
    return false;
  }
};

const storageAvailable = canStore();

const isPlainNavigationClick = (event) => {
  return event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
};

const shouldPreserveScroll = (link) => {
  if (!storageAvailable || !link || link.target === '_blank' || link.hasAttribute('download')) return false;

  const targetUrl = new URL(link.href, window.location.href);
  if (targetUrl.origin !== window.location.origin) return false;

  const currentUrl = new URL(window.location.href);
  currentUrl.hash = '';
  targetUrl.hash = '';

  return targetUrl.href !== currentUrl.href;
};

const rememberScroll = (link) => {
  const payload = {
    expiresAt: Date.now() + RESTORE_TTL,
    targetUrl: normalizeUrl(link.href),
    y: getScrollY(),
  };

  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
};

const restoreScroll = () => {
  if (!storageAvailable) return;

  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }

  const rawPayload = sessionStorage.getItem(STORAGE_KEY);
  if (!rawPayload) return;

  sessionStorage.removeItem(STORAGE_KEY);

  let payload;
  try {
    payload = JSON.parse(rawPayload);
  } catch (_error) {
    return;
  }

  if (!payload || payload.expiresAt < Date.now() || payload.targetUrl !== normalizeUrl(window.location.href)) return;

  const htmlScrollBehavior = document.documentElement.style.scrollBehavior;
  const bodyScrollBehavior = document.body.style.scrollBehavior;
  let restoreComplete = false;

  document.documentElement.style.scrollBehavior = 'auto';
  document.body.style.scrollBehavior = 'auto';

  const scrollToSavedPosition = () => {
    const maxY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    const targetY = Math.min(payload.y, maxY);

    window.scrollTo(0, targetY);
    document.documentElement.scrollTop = targetY;
    document.body.scrollTop = targetY;
  };

  let attempts = 0;
  let userInterrupted = false;
  let restoreTimer;
  const completeRestore = () => {
    if (restoreComplete) return;

    restoreComplete = true;
    if (restoreTimer) window.clearInterval(restoreTimer);
    document.documentElement.style.scrollBehavior = htmlScrollBehavior;
    document.body.style.scrollBehavior = bodyScrollBehavior;
  };
  const stopRestore = () => {
    userInterrupted = true;
    completeRestore();
  };

  ['wheel', 'touchstart', 'keydown'].forEach((eventName) => {
    window.addEventListener(eventName, stopRestore, { once: true, passive: true });
  });

  restoreTimer = window.setInterval(() => {
    attempts += 1;
    scrollToSavedPosition();

    if (attempts >= 120 || userInterrupted) {
      completeRestore();
    }
  }, 100);

  scrollToSavedPosition();
  window.requestAnimationFrame(scrollToSavedPosition);
  window.setTimeout(scrollToSavedPosition, 120);
  window.setTimeout(scrollToSavedPosition, 450);
  window.setTimeout(scrollToSavedPosition, 900);
  window.setTimeout(scrollToSavedPosition, 1500);
  window.addEventListener('load', scrollToSavedPosition, { once: true });
  window.addEventListener('pageshow', scrollToSavedPosition, { once: true });
};

document.addEventListener(
  'click',
  (event) => {
    if (!isPlainNavigationClick(event)) return;

    const target = event.target;
    if (!(target instanceof Element)) return;

    const link = target.closest(LINK_SELECTOR);
    if (!(link instanceof HTMLAnchorElement) || !shouldPreserveScroll(link)) return;

    rememberScroll(link);
  },
  { capture: true }
);

restoreScroll();
